import React, { Fragment, useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { store } from '@Stores/MainStore';
import { numeralFormat } from '@GlobalHelpers';
import { defaults, someOf } from '@Utils/Utils';
import { storeProduct } from '@Stores/StoreProduct';
import { set } from 'js-cookie';

/**
 * @param {object} props
 * @param {number} props.price
 * @param {string} props.currency
 * @param {boolean} props.inline
 * @param {boolean} props.separateLine
 * @param {'none'|'left'|'right'} props.currencyPosition
 */
const PriceWithCurrency = observer(props => { 

    const [lineType, setLineType] = useState('')

    useEffect(() => {
        setLineType(props.inline ? 'inline' : props.separateLine ? 'separate' : '')
    }, [props.inline, props.separateLine])

    const noCurrency = (price) => {
        if (props.separateLine === true) {
            return (<p style={{textAlign:'center'}} className="no-margin cart-text">{price}</p>)
        } else {
            return <Fragment>{price}</Fragment>
        }
    }

    return (
        <>
        {props.currencyPosition ? 
            <>
            {someOf(props.currencyPosition, ['left', 'right']) ?
                <>
                {props.currencyPosition === 'left' && 
                    <CurrencyLeft price={props.price} currency={props.currency} lineType={lineType}/>
                }
                {props.currencyPosition === 'right' && 
                    <CurrencyRight price={props.price} currency={props.currency} lineType={lineType}/>
                }
                </>
                :
                noCurrency(price)
            }
            </>
            : 
            noCurrency(price)
        }
        </>
    )
})

/**
 * @param {object} props
 * @param {'inline'|'separate'} props.lineType
 */
const CurrencyLeft = observer(({ price, currency, lineType = 'inline' }) => {
    if (lineType === 'separate') {
        return (
            <Fragment>
                <p style={{textAlign:'center'}} className="no-margin cart-text">{currency}</p> 
                <p style={{textAlign:'center'}} className="no-margin cart-text">{price}</p>
            </Fragment>
        )
    } else if (lineType === 'inline') {
        return (<p style={{textAlign:'center'}} className="no-margin cart-text">{currency} {price}</p>)
    } else {
        return <Fragment>{currency} {price}</Fragment>
    }
})

/**
 * @param {object} props
 * @param {'inline'|'separate'} props.lineType
 */
const CurrencyRight = observer(({ price, currency, lineType = 'inline' }) => {
    if (lineType === 'separate') {
        return (
            <Fragment>
                <p style={{textAlign:'center'}} className="no-margin cart-text text-xs">{price}</p>
                <p style={{textAlign:'center'}} className="no-margin cart-text text-xs">{currency}</p> 
            </Fragment>
        )
    } else if (lineType === 'inline') {
        return (
            <Fragment>
                <p style={{textAlign:'center'}} className="no-margin cart-text">{price} {currency}</p> 
            </Fragment>
        )
    } else {
        return (<Fragment>{price} {currency}</Fragment>)
    }
})

export default PriceWithCurrency